import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { UserInvitation } from 'generated/graphql';

interface Props {
  isLoading: boolean;
  userInvitations?: UserInvitation[];
}

export const UserInvitationStatsCard: React.FC<Props> = ({ isLoading, userInvitations }) => {
  const lastWeekTimestamp = new Date();
  lastWeekTimestamp.setDate(lastWeekTimestamp.getDate() - 7);

  const userInvitationsLastWeek = userInvitations?.filter(
    (userInvitation) => userInvitation.creationTimestamp >= lastWeekTimestamp,
  );

  return isLoading ? (
    <Skeleton height={96} variant="rectangular" />
  ) : (
    <Card>
      <CardContent>
        <Typography component="div" variant="h5">
          {`${userInvitations?.length} odoslaných pozvánok`}
        </Typography>
        <Typography color="text.secondary">{`${userInvitationsLastWeek?.length} za posledných 7 dní`}</Typography>
      </CardContent>
    </Card>
  );
};
